import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 27rem;
  margin-top: 3.7rem;
  position: relative;
`;

export const Labels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: absolute;
  top: -2.1rem;
  left: 0;
`;

export const LabelLine = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  border-bottom: 0.2rem solid #e5e7eb;

  &:first-child {
    height: 2.2rem;
  }
`;

export const LabelLineText = styled.div`
  width: 3.5rem;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #181c24;
  background: #fff;
  margin-bottom: -0.6rem;
  padding-right: 1.4rem;
  text-align: right;

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 2rem;
  `}
`;

export const Bars = styled.div`
  width: 100%;
  height: calc(100% - 2.2rem);
  margin-bottom: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 5.8rem;
  padding-right: 3.8rem;
  position: relative;

  ${({ theme }) => theme.media.sm`
    padding-left: 2.2rem;
    padding-right: 0;
  `}
`;

export const Bar = styled.div`
  width: 4.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

export const BarValue = styled.div`
  width: 2rem;
  border-top-right-radius: 0.4rem;
  border-top-left-radius: 0.4rem;
  background-color: ${({ theme }) => theme.live.colors.primary};
`;

export const BarText = styled.div`
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.2rem;
  margin: 0.2rem 0 -2.4rem;
  color: #181c24;

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 2rem;
    margin: 0.2rem 0 -2.2rem;
  `}
`;
